// Colours by resource kind, as on screen. They repeat the resources lens legend (src/world/lenses.ts
// RESOURCE_COLORS) so an icon, a heap and a legend swatch of one resource are one colour.

import * as THREE from 'three/webgpu';
import { RESOURCE } from '../../core/schema.ts';

/** Legend colour of each RESOURCE value (index = value). Index 0 (NONE) is unused. */
export const KIND_COLORS: readonly string[] = [
  '#000000',
  '#1b1b1b', // OIL
  '#7fb3d5', // GAS
  '#5d4037', // COAL
  '#c0ca33', // URANIUM
  '#26c6da', // LITHIUM
  '#3949ab', // COBALT
  '#ab47bc', // RARE_EARTHS
  '#e67e22', // COPPER
  '#90a4ae', // IRON
  '#f1c40f', // GOLD
  '#66bb6a', // NICKEL
  '#212f3d', // GRAPHITE
];

export const KIND_FALLBACK = '#8e867a';

/** Display names, in RESOURCE order (also the lens legend's labels). */
export const KIND_NAMES: Readonly<Record<number, string>> = {
  [RESOURCE.OIL]: 'Oil',
  [RESOURCE.GAS]: 'Gas',
  [RESOURCE.COAL]: 'Coal',
  [RESOURCE.URANIUM]: 'Uranium',
  [RESOURCE.LITHIUM]: 'Lithium',
  [RESOURCE.COBALT]: 'Cobalt',
  [RESOURCE.RARE_EARTHS]: 'Rare earths',
  [RESOURCE.COPPER]: 'Copper',
  [RESOURCE.IRON]: 'Iron',
  [RESOURCE.GOLD]: 'Gold',
  [RESOURCE.NICKEL]: 'Nickel',
  [RESOURCE.GRAPHITE]: 'Graphite',
};

/** Colour of a resource kind. */
export function kindColor(kind: number): string {
  return KIND_COLORS[kind] ?? KIND_FALLBACK;
}

/** Heaps stay this far from full saturation, so a pile reads as earth and the chip keeps the colour. */
export const HEAP_MAX_SATURATION = 0.4;

/** The kind's colour with its saturation capped at HEAP_MAX_SATURATION (same hue and lightness). */
export function heapColor(kind: number): THREE.Color {
  const hsl = { h: 0, s: 0, l: 0 };
  new THREE.Color(kindColor(kind)).getHSL(hsl);
  return new THREE.Color().setHSL(hsl.h, Math.min(hsl.s, HEAP_MAX_SATURATION), hsl.l);
}
